import { render, staticRenderFns } from "./AddOrEditReason.vue?vue&type=template&id=7d3fc1a0&scoped=true"
import script from "./AddOrEditReason.vue?vue&type=script&lang=ts"
export * from "./AddOrEditReason.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d3fc1a0",
  null
  
)

export default component.exports